import { TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { SeparatorRadio } from './SeparatorRadio'

export const DataTextArea = (props) => {
  const { tableData, setTableData, setSeparator } = props
  const handleChange = (value) => {
    setTableData(value)
  }

  return (
    <Box p={4}>
      <SeparatorRadio
        setSeparator={setSeparator}
      />
      <TextField
        label="Your Table Data"
        multiline
        rows={15}
        value={tableData}
        onChange={(e) => handleChange(e.target.value)}
        sx={{ marginTop: "1rem", width: "100%", height: "100%" }}
        spellCheck={false}
      />
      <Typography mt={2}>
        <strong>How to merge cells</strong><br />
        Merge with left cell: Please Enter {"[<]"}.<br />
        Merge with upper cell: Please Enter {"[^]"}.
      </Typography>
    </Box>
  )
}
